const GENDER_TO_SALUTATION_KEY_MAP: Record<string, string> = {
  m: 'm',
  w: 'w',
  f: 'w',
}

export const getSalutationKey = (gender: string = '') => {
  return GENDER_TO_SALUTATION_KEY_MAP[gender] || 'fallback'
}
